module.exports = __webpack_public_path__ + "static/media/setup-user.c240e189.svg";